import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { MDBContainer } from "mdb-react-ui-kit";

const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());

    // eslint-disable-next-line no-continue
    if (a === b) continue;

    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

export function useEffectOnce(effect) {
  useEffect(effect, []);
}
const AppBuildVersion = () => {
  const [cookies, setCookie] = useCookies(["appUser"]);
  const [currentBuildVersion, setAppVersion] = useState(
    cookies.appUser?.appVersion || "0.0.0"
  );
  const [error, setError] = useState(null);

  const getAppVersion = () => {
    fetch("appVersion.json", {
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        const shouldForceRefresh = semverGreaterThan(
          data.appVersion,
          currentBuildVersion
        );
        if (shouldForceRefresh) {
          console.log(
            `We have a new version - ${data.appVersion}. Should force refresh`
          );
          setCookie(
            "appUser",
            { appVersion: data.appVersion },
            {
              path: "/",
            }
          );
          setAppVersion(data.appVersion);
          window.location.reload();
        } else {
          console.log(
            `You already have the latest version - ${data.appVersion}. No cache refresh needed.`
          );
        }
        setAppVersion(data.appVersion);
      })
      .catch((error) => {
        console.error("Error fetching app version:", error);
        setError(error.message);
      });
  };

  useEffect(() => {
    getAppVersion();
  }, []); // Use useEffect instead of useEffectOnce for better testing

  if (error) {
    return (
      
        <div className="d-flex justify-content-end text-end">
          <small>Error: {error}</small>
        </div>
      
    );
  }

  return (
    
      <div className="d-flex justify-content-end text-end">
        <small>Build: {currentBuildVersion}</small>
      </div>
    
  );
};

export { semverGreaterThan };

export default AppBuildVersion;
